var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyShopList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#615E5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 25.75C20.0938 25.75 20 25.6562 20 25.5V24.5C20 24.375 20.0938 24.25 20.25 24.25H24.75C24.875 24.25 25 24.375 25 24.5V25.5C25 25.6562 24.875 25.75 24.75 25.75H20.25ZM17.5 26C17.2188 26 17 25.7812 17 25.5V24.5C17 24.25 17.2188 24 17.5 24H18.5C18.75 24 19 24.25 19 24.5V25.5C19 25.7812 18.75 26 18.5 26H17.5ZM17.5 22C17.2188 22 17 21.7812 17 21.5V20.5C17 20.25 17.2188 20 17.5 20H18.5C18.75 20 19 20.25 19 20.5V21.5C19 21.7812 18.75 22 18.5 22H17.5ZM20.25 21.75C20.0938 21.75 20 21.6562 20 21.5V20.5C20 20.375 20.0938 20.25 20.25 20.25H24.75C24.875 20.25 25 20.375 25 20.5V21.5C25 21.6562 24.875 21.75 24.75 21.75H20.25ZM17.5 18C17.2188 18 17 17.7812 17 17.5V16.5C17 16.25 17.2188 16 17.5 16H18.5C18.75 16 19 16.25 19 16.5V17.5C19 17.7812 18.75 18 18.5 18H17.5ZM20.25 17.75C20.0938 17.75 20 17.6562 20 17.5V16.5C20 16.375 20.0938 16.25 20.25 16.25H24.75C24.875 16.25 25 16.375 25 16.5V17.5C25 17.6562 24.875 17.75 24.75 17.75H20.25ZM27 13C27.5312 13 28 13.4688 28 14V28C28 28.5625 27.5312 29 27 29H15C14.4375 29 14 28.5625 14 28V14C14 13.4688 14.4375 13 15 13H27ZM26.5 27.5V14.5H15.5V27.5H26.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyShopList);
export default __webpack_public_path__ + "static/media/greyShopList.aadfd2bfcad91433f3380e615b56ac67.svg";
export { ForwardRef as ReactComponent };